import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBase } from "../base";

export const Material = types
  .compose(
    Base,
    types.model({
      code: types.maybeNull(types.string),
      barcode: types.maybeNull(types.string),
      type: types.maybeNull(types.string),
      name: types.maybeNull(types.string),
      specificationThick: types.maybeNull(types.number),
      specificationSize: types.maybeNull(types.number),
      specificationLength: types.maybeNull(types.number),
      allowedInventory: types.maybeNull(types.string),
    }),
  )
  .actions(withSetPropAction);
export interface IMaterial extends Instance<typeof Material> {}
export interface IMaterialProperties extends SnapshotIn<typeof Material> {}
export interface IAddMaterial extends Omit<IMaterialProperties, keyof IBase> {}
export interface IUpdateMaterial extends IMaterialProperties {}
